import { createStore } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';

import { keyBuilder } from '@/react/hooks/useLocalStorage';

import { EnvironmentId } from '../portainer/environments/types';

export const environmentStore = createStore<{
  environmentId?: number;
  isInEnvironmentRoute: boolean;
  setEnvironmentId(id: EnvironmentId): void;
  setIsInEnvironmentRoute(value: boolean): void;
  clear(): void;
}>()(
  subscribeWithSelector(
    persist(
      (set) => ({
        environmentId: undefined,
        isInEnvironmentRoute: false,
        setEnvironmentId: (id: EnvironmentId) => set({ environmentId: id }),
        setIsInEnvironmentRoute: (value: boolean) =>
          set({ isInEnvironmentRoute: value }),
        clear: () => set({ environmentId: undefined }),
      }),
      {
        name: keyBuilder('environmentId'),
        getStorage: () => sessionStorage,
      }
    )
  )
);
